export default "__VITE_ASSET__BoOPc34m__"